import MarkdownIt from 'markdown-it'

export async function mdToHtml(postData) {
  const md = new MarkdownIt({html: true, breaks: true, linkify: true});
  // Remember old renderer, if overridden, or proxy to default renderer
  const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    // If you are sure other plugins can't add `target` - drop check below
    const aIndex = tokens[idx].attrIndex('target');

    if (aIndex < 0) {
      tokens[idx].attrPush(['target', '_blank']); // add new attribute
    } else {
      tokens[idx].attrs[aIndex][1] = '_blank';    // replace value of existing attr
    }

    // pass token to default renderer.
    return defaultRender(tokens, idx, options, env, self);
  };

  return postData.attributes.sections.map(section => {
    if (section.content) {
      section.content = md.render(section.content);
    }
    if (section.description) {
      section.description = md.render(section.description);
    }
    return section;
  });
}

export async function TeamMdToHtml(teamData) {
  const md = new MarkdownIt({html: true});

  return teamData.attributes.members.map(member => {
    if (member.description) {
      member.description = md.render(member.description);
    }
    return member;
  });
}
